import script from "./Race2023.vue?vue&type=script&setup=true&lang=js"
export * from "./Race2023.vue?vue&type=script&setup=true&lang=js"

import "./Race2023.vue?vue&type=style&index=0&id=e4e256ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4e256ce"]])

export default __exports__